<?xml version="1.0" encoding="utf-8"?>
<gpx xmlns="http://www.topografix.com/GPX/1/1" version="1.1" creator="https://mapy.com/">
	<wpt lat="49.526090" lon="15.349630">
		<ele>590.098572</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.533330" lon="15.334524">
		<ele>590.376587</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.549816" lon="15.328344">
		<ele>546.754211</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.560562" lon="15.312380">
		<ele>573.121765</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.565460" lon="15.288176">
		<ele>523.074158</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.570720" lon="15.294810">
		<ele>572.128540</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.581436" lon="15.299591">
		<ele>596.133301</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.586500" lon="15.301994">
		<ele>604.200012</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.588170" lon="15.316156">
		<ele>618.328796</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.589336" lon="15.342764">
		<ele>574.000061</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.576035" lon="15.357613">
		<ele>492.000000</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.563400" lon="15.371946">
		<ele>507.925507</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.551430" lon="15.376839">
		<ele>548.113464</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.523415" lon="15.379328">
		<ele>627.167786</ele>
		<name>Nový bod</name>
	</wpt>
	<wpt lat="49.524918" lon="15.366024">
		<ele>622.507507</ele>
		<name>Nový bod</name>
	</wpt>
</gpx>

